<script setup>
import bgHero from '@/assets/img/bg-our-works.png'
import BlogOurWorks from '../components/BlogOurWorks.vue';
import { ref, onMounted } from 'vue'
import { fetchWorkSlides } from '@/services/api'
import DynamicHero from '../components/DynamicHero.vue'
const slides = ref([])
const isLoading = ref(true)
onMounted(async () => {
    try {
        isLoading.value = true
        const data = await fetchWorkSlides()
        slides.value = data || []
    } catch (error) {
        console.error('Failed to load works data:', error)
    } finally {
        isLoading.value = false
    }
})
</script>


<template>

    <DynamicHero :slides="slides" :fallbackBg="bgHero"
        fallbackTitle="A showcase of stories we’ve brought to life through visuals, creativity, and purposeful storytelling."
        fallbackDescription=" From corporate films to campaign visuals, each project reflects our commitment to quality,creativity, and meaningful impact."
        fallbackButtonText="Consultation Now" fallbackButtonLink="/services" breadcrumbLabel="Our Works" />


    <BlogOurWorks />
</template>
